/**
 * @fileoverview Offscreen-слой следов шин / уборочной техники.
 */

import { H, W } from "../constants/world";

/** Мутабельный canvas следов — оверлей на поле. */
export class TrackLayer {
  readonly canvas = document.createElement("canvas");
  private readonly ctx: CanvasRenderingContext2D;

  constructor() {
    this.canvas.width = W;
    this.canvas.height = H;
    const ctx = this.canvas.getContext("2d");
    if (!ctx) throw new Error("2d context unavailable for tracks");
    this.ctx = ctx;
  }

  clear(): void {
    this.ctx.clearRect(0, 0, W, H);
  }

  /** Отпечаток шин. */
  track(x: number, y: number, r: number): void {
    const c = this.ctx;
    c.globalCompositeOperation = "source-over";
    c.fillStyle = "rgba(96,138,190,.18)";
    c.beginPath();
    c.arc(x, y, r, 0, 7);
    c.fill();
  }

  /** След отвала снегоочистителя. */
  plow(x: number, y: number, h: number): void {
    const c = this.ctx;
    c.globalCompositeOperation = "source-over";
    c.fillStyle = "rgba(70,110,160,.20)";
    c.fillRect(x - 6, y - h, 8, h * 2);
  }

  /** Постепенное затухание следов. */
  fade(dt: number): void {
    const c = this.ctx;
    c.globalCompositeOperation = "destination-out";
    c.fillStyle = `rgba(0,0,0,${dt * 0.3})`;
    c.fillRect(0, 0, W, H);
    c.globalCompositeOperation = "source-over";
  }
}
